import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DxDrawerModule } from 'devextreme-angular/ui/drawer';
import { AdminSidenavComponent } from '../admin-sidenav/admin-sidenav.component';
import { AdminToolbarComponent } from '../admin-toolbar/admin-toolbar.component';

@Component({
  selector: 'admin-layout',
  standalone: true,
  imports: [RouterOutlet, DxDrawerModule, AdminSidenavComponent, AdminToolbarComponent],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent {
  readonly sidebarOpen = signal(true);

  toggleSidebar(): void {
    this.sidebarOpen.update(v => !v);
  }
}
